import { byId, isAr, message, copyText, trackEvent } from './extra-common.js';

const input = byId('jf-input');
const output = byId('jf-output');
const indent = byId('jf-indent');
function repairJson(str) {
  let s = str.trim();
  s = s.replace(/\/\*[\s\S]*?\*\/|([^:]|^)\/\/.*$/gm, '$1');
  s = s.replace(/\bTrue\b/g, 'true').replace(/\bFalse\b/g, 'false').replace(/\bNone\b/g, 'null');
  s = s.replace(/(')(?:(?=(\\?))\2.)*?\1/g, (match) => {
    return `"${match.slice(1, -1).replace(/\\'/g, "'").replace(/"/g, '\\"')}"`;
  });
  s = s.replace(/([{,]\s*)([a-zA-Z0-9_$-]+)\s*:/g, '$1"$2":');
  s = s.replace(/,\s*([}\]])/g, '$1');
  return JSON.parse(s);
}

const fmt = (compact = false) => {
  trackEvent('tool_started', 'json-formatter');
  const spaces = indent.value === 'tab' ? '\t' : Number(indent.value);
  try {
    const parsed = JSON.parse(input.value);
    output.value = JSON.stringify(parsed, null, compact ? 0 : spaces);
    message('jf-status', isAr ? 'JSON سليم وتم التحقق من الصياغة بنجاح.' : 'Valid JSON. Syntax checked.', 'success');
    byId('jf-copy').disabled = false;
    trackEvent('tool_completed', 'json-formatter');
  } catch (error) {
    try {
      const repaired = repairJson(input.value);
      output.value = JSON.stringify(repaired, null, compact ? 0 : spaces);
      message('jf-status', isAr ? 'تم إصلاح أخطاء الصياغة وتنسيق JSON تلقائياً (إزالة الفواصل الزائدة وتصحيح المفاتيح)!' : 'Auto-repaired syntax and formatted JSON successfully!', 'success');
      byId('jf-copy').disabled = false;
      trackEvent('tool_completed', 'json-formatter', { auto_repaired: true });
    } catch {
      const match = /position (\d+)/i.exec(error.message);
      const position = match ? Number(match[1]) : 0;
      const before = input.value.slice(0, position);
      const line = before.split('\n').length;
      const column = position - before.lastIndexOf('\n');
      output.value = '';
      message('jf-status', isAr ? `صياغة غير صحيحة قرب السطر ${line}، العمود ${column}: ${error.message}` : `Invalid syntax near line ${line}, column ${column}: ${error.message}`, 'error');
      byId('jf-copy').disabled = true;
      trackEvent('tool_failed', 'json-formatter');
    }
  }
};

byId('jf-format').addEventListener('click', () => fmt(false));
byId('jf-minify').addEventListener('click', () => fmt(true));
byId('jf-clear').addEventListener('click', () => { input.value = ''; output.value = ''; message('jf-status', ''); byId('jf-copy').disabled = true; });
byId('jf-copy').addEventListener('click', async () => { try { await copyText(output.value); message('jf-status', isAr ? 'تم نسخ JSON.' : 'JSON copied.', 'success'); } catch { message('jf-status', isAr ? 'تعذر النسخ.' : 'Copy failed.', 'error'); } });
input.addEventListener('input', () => { if (!input.value.trim()) { output.value = ''; message('jf-status', ''); } });
